import { useRouter } from "next/router";
import useSWR from "swr";
import { fetcher } from "../../../common/hooks";
import { Announcement } from "../models";

const URL = "/api/notification-management/v1/announcements/live";

interface UseLiveAnnouncementsOptions {
    onSuccess?: (data: Announcement[]) => void;
}

export const useLiveAnnouncements = (options?: UseLiveAnnouncementsOptions) => {
    const { locale } = useRouter();

    const { data, error, isLoading } = useSWR<Announcement[]>(
        [URL, locale],
        ([url, currentLocale]: [string, string | undefined]) =>
            fetcher(url, { locale: currentLocale }),
        {
            fallbackData: [],
            onSuccess: options?.onSuccess,
            revalidateOnFocus: false,
            revalidateOnReconnect: false,
        }
    );

    return {
        liveAnnouncements: data ?? [],
        isLoadingLiveAnnouncements: isLoading,
        errorLiveAnnouncements: error,
    };
};
